var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRpDownArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.07079 9.90446L6.99996 9.90854L6.99996 11.0834L11.0833 11.0834L11.0833 7.00004L9.90846 7.00004L9.90438 9.07087L3.75021 2.91671L2.91663 3.75029L9.07079 9.90446Z",
    fill: "#F93D3D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRpDownArrow);
export default __webpack_public_path__ + "static/media/rp_down_arrow.fa7cb168f8ce1bea878b4f5e0b7d805d.svg";
export { ForwardRef as ReactComponent };